<!-- Item Start Outlet -->
<ng-template [cxOutlet]="CartOutlets.ITEM" [formGroup]="form">
  <!-- Item Description -->
  <td attr.data-label="{{ 'cartItems.item' | cxTranslate }}"
    class="article"
    [ngClass]="{'article-parent' : !isOrderDetails && item.parent}">
    <!-- Item Name -->
    @if (item.product.name) {
      <div class="cx-name">
        @if (item.productAvailable) {
          <a class="cx-link"
            [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
            [queryParams]="{ source: pdpCallSource }"
          cxModal="dismiss">{{ item.product.name }}</a>
        } @else {
          <span>{{ item.product.name }}</span>
        }
      </div>
    }
    <!-- Item Code -->
    @if (item.product.manufacturerAID) {
      <div class="cx-code article-info">
        {{ item.product.manufacturerAID }}
        @if (item.product.manufacturer) {
          <span
          >&nbsp;/&nbsp;{{ item.product.manufacturer }}</span>
        } @else {
          @if (item.product.manufacturerId) {
            <span
            >&nbsp;/&nbsp;{{ item.product.manufacturerId }}</span>
          }
        }
      </div>
    }
    <!-- Item SubstitutedOemNumber -->
    @if (item.substitutedOemNumber && item?.substitutedOemNumber !== item?.product?.manufacturerAID && !compact) {
      <div
        class="searched-article-info">
        <span
          class="u-font-bold">{{ 'cartAdministration.cartItems.searchedArticleNumber' | cxTranslate }}
        :&nbsp;</span>
        <span class="substitutedOemNumber">{{ item.substitutedOemNumber }}</span>
        @if ((item?.substitutedOemNumber !== item?.product?.manufacturerAID)) {
          <button
            class="info-btn"
            [cxPopover]="substitutInfo"
        [cxPopoverOptions]="{
        placement: 'top',
        class: 'my-company-popover',
        displayCloseButton: true
        }">
          </button>
        }
      </div>
    }

    @if (compact) {
      @if (item.basePrice) {
        <div class="cx-code">
          {{ item.basePrice?.formattedValue }}
        </div>
      }
    }

    <!-- Item Details Outlet -->
    <ng-template [cxOutlet]="CartOutlets.ITEM_DETAILS"></ng-template>

    <!-- Variants -->
    @if (item.product.baseOptions?.length) {
      @for (variant of item.product.baseOptions[0]?.selected?.variantOptionQualifiers; track variant) {
        <div
          class="cx-property">
          @if (variant.name && variant.value) {
            <div class="cx-label">
              {{ variant.name }}: {{ variant.value }}
            </div>
          }
        </div>
      }
    }

    <!-- Item Bundle Details Outlet -->
    <ng-template [cxOutlet]="CartOutlets.ITEM_BUNDLE_DETAILS"></ng-template>

    <!-- Promotion -->
    @if (appliedProductPromotions$ | async; as appliedProductPromotions) {
      <cx-promotions [promotions]="appliedProductPromotions"></cx-promotions>
    }
  </td>
  <!-- Item StatusDisplay -->
  @if (item.statusDisplay) {
    <td attr.data-label="{{ 'cartAdministration.cartItems.status' | cxTranslate }}" class="status">
      <div>{{ item.statusDisplay }}</div>
    </td>
  }

  @if (!compact) {
    <!-- Item Quantity -->
    <td attr.data-label="{{ 'cartItems.quantity' | cxTranslate }}" class="quantity">
      <div class="cx-value">
        <app-efa-item-counter [control]="quantityControl"
          [readonly]="!item.updateable || readonly || options.isSaveForLater || item.parent || fromConfigurator"
          [ngClass]="{ 'order-detail-items-counter' : isOrderDetails }"
          [allowZero]="true">
        </app-efa-item-counter>
      </div>
    </td>
    <!-- Availability -->
    <td attr.data-label="{{ 'cartAdministration.cartItems.available' | cxTranslate }}"
      class="available align-center">
      @for (del of item.deliveryItems; track del) {
        <div>{{ del.availableQuantity }}</div>
      }
    </td>
    <!-- Item delivery date -->
    <td attr.data-label="{{ 'cartAdministration.cartItems.deliveryDate' | cxTranslate }}"
      class="delivery-date align-center">
      @for (del of item.deliveryItems; track del) {
        @if (del.deliveryDate) {
          <div>{{ del.deliveryDate | date: 'dd.MM.yyyy' }}</div>
        } @else {
          <div>-</div>
        }
      }
    </td>
    <!-- Item Warehouse -->
    <td attr.data-label="{{ 'cartAdministration.cartItems.warehouse' | cxTranslate }}"
      class="warehouse align-center">
      @for (del of item.deliveryItems; track del) {
        @if (del.warehouseName) {
          <div>{{ del.warehouseName }}</div>
        } @else {
          <div>-</div>
        }
      }
    </td>
    <!-- no Return Policy -->
    <td attr.data-label="{{ 'cartAdministration.cartItems.noReturnPolicy.label' | cxTranslate }}"
      class="available align-center">
      <div [style]="item.noReturnPolicy ? 'color: red' : ''">{{ item.noReturnPolicy !== undefined ? (item.noReturnPolicy ? ('cartAdministration.cartItems.noReturnPolicy.no' | cxTranslate) : ('cartAdministration.cartItems.noReturnPolicy.yes' | cxTranslate)) : '-' }}</div>
    </td>
    <!-- Item Price -->
    @if (item.basePrice) {
      @if (!fromConfigurator) {
        <td
          attr.data-label="{{ 'cartItems.itemPriceRrp' | cxTranslate }}"
          class="price align-center">
          @if (item.basePrice) {
            <div class="cx-value">
              {{ item.basePrice?.formattedValue }}
              @if (item.exchangeTaxRequired) {
                <sup class="exchange-tax-required">*</sup>
              }
            </div>
          }
        </td>
      } @else {
        <td attr.data-label="{{ 'cartItems.itemPrice' | cxTranslate }}"
          class="price align-center">
          @if (item.basePrice) {
            <div class="cx-value">
              {{ item.basePrice?.formattedValue }}
              @if (item.exchangeTaxRequired) {
                <sup class="exchange-tax-required">*</sup>
              }
            </div>
          }
        </td>
      }
    }
    <!-- Total -->
    @if (options.isSaveForLater) {
      <td attr.data-label="{{ 'saveForLaterItems.stock' | cxTranslate }}"
        class="total align-center">
        @if (item.product?.stock?.stockLevel >= 0) {
          <div
            class="cx-value">
            {{ item.product.stock.stockLevel }}
          </div>
        } @else {
          <div class="cx-value">
            {{ 'saveForLaterItems.forceInStock' | cxTranslate }}
            @if (item.exchangeTaxRequired) {
              <sup class="exchange-tax-required">*</sup>
            }
          </div>
        }
      </td>
    } @else {
      @if (displayCustomerPrices$ | async) {
        @if (item.customerTotalPrice) {
          <td attr.data-label="{{ 'cartItems.total' | cxTranslate }}"
            class="price align-center">
            @if (item.customerTotalPrice) {
              <div class="cx-value">
                {{ item.customerTotalPrice?.formattedValue }}
                @if (item.exchangeTaxRequired) {
                  <sup class="exchange-tax-required">*</sup>
                }
              </div>
            }
          </td>
        }
      } @else {
        @if (item.totalPrice) {
          <td attr.data-label="{{ 'cartItems.total' | cxTranslate }}"
            class="price align-center">
            @if (item.totalPrice) {
              <div class="cx-value">
                {{ item.totalPrice?.formattedValue }}
                @if (item.exchangeTaxRequired) {
                  <sup class="exchange-tax-required">*</sup>
                }
              </div>
            }
          </td>
        }
      }
    }
    <!-- Actions -->
    <td attr.data-label="{{'cartAdministration.cartItems.commission' | cxTranslate }}">
      @if (!readonly && !consignmentInfoEditable) {
        <cx-icon type="PENCIL"
          ngbTooltip="{{ 'cartAdministration.cartItems.actions.editCommission' | cxTranslate }}"
          placement="top"
          (click)="toggleConsignmentInfo()"
        class="u-pointer"></cx-icon>
      }
      @if (!readonly && consignmentInfoEditable) {
        <cx-icon type="ARROW_UP"
          (click)="toggleConsignmentInfo()"
          ngbTooltip="{{ 'cartAdministration.cartItems.actions.hideCommission' | cxTranslate }}"
        class="u-pointer"></cx-icon>
      }
    </td>
    @if (!fromConfigurator || isOrderDetails) {
      <td
        attr.data-label="{{ 'cartAdministration.cartItems.wishlist' | cxTranslate }}">
        <app-efa-cart-item-add-to-wish-list [product]="item.product"
        [orderInfoRefId]="item.orderInfoRefId"></app-efa-cart-item-add-to-wish-list>
      </td>
    }
    @if (!readonly && !item.parent && item.updateable && !fromConfigurator) {
      <td
        attr.data-label="{{ 'cartAdministration.cartItems.actions.delete' | cxTranslate }}"
        class="action">
        <cx-icon type="CLEAR"
          (click)="removeItem()"
          ngbTooltip="{{ 'cartAdministration.cartItems.actions.delete' | cxTranslate }}"
        class="u-pointer"></cx-icon>
      </td>
    }
  }
</ng-template>
<ng-template #substitutInfo>
  <div class="popover-details">
    <div class="property">
      {{ 'cartAdministration.cartItems.substitutInfoMessage' | cxTranslate }}
    </div>
  </div>
</ng-template>

